import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'

import './styles/global.less'

// import initializeServiceWorker from './lib/serviceWorker'

const init = async function () {
  await store.dispatch('common/getBaseInfo')
  // await initializeServiceWorker()

  createApp(App).use(store).use(router).use(i18n).mount('#app')
}

init()
